import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

const ProductUpdateForm = ({ show, onHide, update, onSubmit }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    type: 'live', // Default type
  });

  useEffect(() => {
    if (update) {
      setFormData({
        title: update.title,
        description: update.description,
        type: update.type || 'live',
      });
    }
  }, [update]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (update) {
      onSubmit(update._id, formData);
    } else {
      onSubmit(formData);
    }
    onHide();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{update ? t('editUpdate') : t('createNewUpdate')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Form Section */}
          <div className="w-full">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-white">
                  {t('title')}
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-white">
                  {t('type')}
                </label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  required
                >
                  <option value="live">Live</option>
                  <option value="bot">Bot</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-white">
                  {t('description')}
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 h-32"
                />
              </div>
              <div className="flex justify-end pt-4">
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#E8FC8B] text-[#1B2D1A] hover:bg-[#E8FC8B]/90 disabled:opacity-50 disabled:cursor-not-allowed rounded-md"
                >
                  {update ? t('saveChanges') : t('createUpdate')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductUpdateForm; 
